import React from 'react';
import { View } from 'react-native';
import Stepper from '../../stepper/Stepper';
import { BottomBarDLSType, ButtonTypeDLS, ColorTokens, DividerSizeTokens, FontSizeTokens, SizeTypeTokens, StepperTypeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import BottomBar from '../../bottomBarDLS/bottomBarDLS';
import { Typography } from '../../typography/Typography';
import Space from '../../space/Space';
import Divider from '../../divider/Divider';
import { isFontMobile } from '../../stack/utils';
const paymentSuccessFullScreen = ({ stepperData, height, amountCollected, transactionalRefNumber, paymentMode, navigateAction, triggerAction }) => {
    const body = () => {
        return (React.createElement(View, { style: { marginTop: 36 } },
            React.createElement(View, { style: { paddingHorizontal: 16, paddingTop: 16, borderRadius: 16, borderWidth: 1, borderColor: '#E4E7EC' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Repayment amount', color: ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.SM }),
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(Typography, { label: `₹`, fontWeight: '700', fontSize: isFontMobile() ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile() ? 40 : 32 }),
                    React.createElement(Typography, { label: amountCollected ? amountCollected.substr(1) : "", typeDLS: TypographyTypeDLS.H1B })),
                React.createElement(View, { style: { marginTop: 16, marginBottom: 24, marginHorizontal: -16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: stepperData, isProcessing: true })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Transaction reference number', color: ColorTokens.Grey_Charcoal }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: transactionalRefNumber })),
            React.createElement(View, { style: { marginVertical: 16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Payment mode', color: ColorTokens.Grey_Charcoal }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: paymentMode })));
    };
    const footer = () => {
        return (React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLabel: 'Done', btnTypeDLS: ButtonTypeDLS.PRIMARY, onPress: () => {
                if (navigateAction)
                    triggerAction(navigateAction);
            }, isPositionAbsolute: true }));
    };
    return (React.createElement(BoilerPlate, { height: height - 16, bottomChildren: React.createElement(React.Fragment, null, footer()), backgroundColor: ColorTokens.White },
        React.createElement(React.Fragment, null, body())));
};
export default paymentSuccessFullScreen;
